import {
  FETCH_AI_SETTINGS,
  UPDATE_AI_SETTINGS,
  SET_AI_SETTINGS_LOADING,
  SET_AI_SETTINGS_ERROR
} from '../Actions/AI/type';

const initialState = {
  ai_sense: false,
  ai_listen: true,
  loading: false,
  error: null
};

export default function aiSettings(state = initialState, action) {
  switch (action.type) {
    case SET_AI_SETTINGS_LOADING:
      return { ...state, loading: true, error: null };
    case SET_AI_SETTINGS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case FETCH_AI_SETTINGS:
    case UPDATE_AI_SETTINGS:
      return {
        ...state,
        loading: false,
        error: null,
        ai_sense: !!action.payload?.ai_sense,
        ai_listen: !!action.payload?.ai_listen
      };
    default:
      return state;
  }
}
